import { ICalculatorValues, ISliderValues } from '../types';
import React from 'react';

interface ICalculatorCheatSheetProps {
  calculatorValues: ICalculatorValues;
  legendValues: ICalculatorValues;
  secondSliderText: string;
  firstSliderText: string;
  firstSliderValues: ISliderValues;
  secondSliderValues: ISliderValues;
}

const CalculatorCheatSheet: React.FC<ICalculatorCheatSheetProps> = ({
  calculatorValues,
  legendValues,
  secondSliderText,
  firstSliderText,
  firstSliderValues,
  secondSliderValues,
}) => {
  if (!calculatorValues) return null;

  return (
    <>
      <div className="calculator-cheatsheet">
        <table>
          <tr>
            <th>
              {secondSliderText} ➡️
              <br />
              {firstSliderText} ⬇️
            </th>
            {secondSliderValues?.map(
              (secondSliderValue, secondSliderValueIndex) => (
                <th key={secondSliderValueIndex}>{secondSliderValue}</th>
              )
            )}
          </tr>
          {calculatorValues.map(
            (firstSliderOptions, firstSliderOptionsIndex) => {
              return (
                <tr key={firstSliderOptionsIndex}>
                  <th>
                    {firstSliderValues?.length &&
                      firstSliderValues[firstSliderOptionsIndex]}
                  </th>
                  {firstSliderOptions.map((option, optionIndex) => (
                    <td key={optionIndex}>
                      {option} /{' '}
                      {legendValues &&
                        legendValues[firstSliderOptionsIndex][optionIndex]}
                    </td>
                  ))}
                </tr>
              );
            }
          )}
        </table>
      </div>
      <style jsx>{`
        .calculator-cheatsheet {
          margin-bottom: var(--space-6);
        }
        .calculator-cheatsheet table {
          border-collapse: collapse;
        }
        .calculator-cheatsheet table th,
        .calculator-cheatsheet table td {
          border: 1px solid black;
          padding: var(--space-1);
        }
      `}</style>
    </>
  );
};

export default CalculatorCheatSheet;
